"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeNotification = exports.showNotification = exports.requestNotificationsPermission = exports.getNotificationsPermission = exports.terminateNotifications = exports.initializeNotifications = void 0;
const notification_support_1 = require("./notification-support");
const notification_callback_1 = require("./notification-callback");
const uuid_1 = require("uuid");
// The native binary will be loaded lazily to avoid any possible crash at start
// time, which are harder to trace.
let _nativeModule = undefined;
function getNativeModule() {
    if (_nativeModule !== undefined) {
        return _nativeModule;
    }
    _nativeModule = (0, notification_support_1.supportsNotifications)()
        ? require('../build/Release/desktop-notifications.node')
        : null;
    return _nativeModule;
}
/** Initializes the desktop-notifications system. */
const initializeNotifications = opts => getNativeModule()?.initializeNotifications(notification_callback_1.notificationCallback, opts);
exports.initializeNotifications = initializeNotifications;
/** Terminates the desktop-notifications system. */
const terminateNotifications = () => getNativeModule()?.terminateNotifications();
exports.terminateNotifications = terminateNotifications;
/** Gets the current state of the notifications permission. */
const getNotificationsPermission = () => getNativeModule()?.getNotificationsPermission();
exports.getNotificationsPermission = getNotificationsPermission;
/** Requests the user to grant permission to display notifications. */
const requestNotificationsPermission = () => getNativeModule()?.requestNotificationsPermission();
exports.requestNotificationsPermission = requestNotificationsPermission;
/**
 * Displays a system notification.
 * @param title Title of the notification
 * @param body Body of the notification
 * @param userInfo (Optional) An object with any information that needs to be
 * passed to the notification callback when the user clicks on the notification.
 * @returns The ID of the notification displayed. This ID can be used to close
 * the notification.
 */
const showNotification = async (...args) => {
    const id = (0, uuid_1.v4)();
    try {
        await getNativeModule()?.showNotification(id, ...args);
    }
    catch (e) {
        return null;
    }
    return id;
};
exports.showNotification = showNotification;
/** Closes the notification with the given ID. */
const closeNotification = (...args) => getNativeModule()?.closeNotification(...args);
exports.closeNotification = closeNotification;
//# sourceMappingURL=native-module.js.map